export interface CompanyInfoPatch {
  companyName?: string
  dic?: string
  country?: string
  city?: string
  street?: string
  zip?: string
}

export type CompanyRegisterProvider = 'ares' | 'rpo'
export type CompanyRegisterLookupStatus = 'unknown' | 'active' | 'terminated'
export type CompanyRegisterLookupErrorCode = 'invalid-ico' | 'not-found' | 'ambiguous' | 'unavailable'

export interface CompanyRegisterLookupResult {
  values: CompanyInfoPatch
  status: CompanyRegisterLookupStatus
}

export class CompanyRegisterLookupError extends Error {
  constructor(public readonly code: CompanyRegisterLookupErrorCode) {
    super(code)
    this.name = 'CompanyRegisterLookupError'
  }
}
